import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store/src/models';
import { UserAuthorizationActions } from 'app/modules/main/store/user-authorization/user-authorization.actions';
import { UserAuthorizationState } from 'app/modules/main/store/user-authorization/user-authorization.state';

export class UserAuthorizationReducer {

  private static readonly initialState: UserAuthorizationState = { authorization: undefined };

  private static readonly userClaimingAuthorizationForAccount = on(
    UserAuthorizationActions.userClaimingAuthorizationForAdvertiserAccount,
    UserAuthorizationActions.userClaimingAuthorizationForPublisherAccount,
    (_state: UserAuthorizationState) => UserAuthorizationReducer.initialState,
  );

  private static readonly userAuthorizedForAccount = on(
    UserAuthorizationActions.userAuthorizedForAdvertiserAccount,
    UserAuthorizationActions.userAuthorizedForPublisherAccount,
    UserAuthorizationActions.userAuthorizationRefreshedForAdvertiserAccount,
    UserAuthorizationActions.userAuthorizationRefreshedForPublisherAccount,
    (state: UserAuthorizationState, { authorization }) => ({ authorization }),
  );

  static reducer(): ActionReducer<UserAuthorizationState> {

    return <ActionReducer<UserAuthorizationState>>createReducer(
      UserAuthorizationReducer.initialState,
      UserAuthorizationReducer.userClaimingAuthorizationForAccount,
      UserAuthorizationReducer.userAuthorizedForAccount,
    );
  }

}
